import React, { Component } from "react";
import styles from "./../reportTable.module.scss";
import { withReportsList } from "../../../shared/containers/containerReportsList";

const rowStyles = [styles.reportTableRowItemBackground, styles.reportTableRowItem];

class GeoZoneByDayContent extends Component {
  constructor(props) {
    super(props);

    this.state = { columnsData: {} };
  }

  componentDidMount() {
    const { columnsData } = this.state;
    const { reportsListData } = this.props;

    const report = reportsListData.filter((x) => {
      return x.buildType === 14 && x.reportType === 4;
    })[0];


    report.fields.forEach((field) => {
      columnsData[field.dashboard.codes] = field.cssColumnWidth;
    });

    this.setState({ columnsData });
  }

  getRowCell(key, value, rowStyle) {
    const { columnsData } = this.state;

    return (
      <div className={rowStyle} style={{ width: columnsData[key] + "px", border: "none" }}>
        <span style={{ border: "none" }}>{value}</span>
      </div>
    );
  }

  getDayContent(day) {
    return (
      <div>
        <div>
          <b>{day.day}</b>
          {day.rows.map((row, index) => {
            const rowStyle = (index & 1) === 0 ? rowStyles[1] : rowStyles[0];

            return (
              <div className={styles.reportTableRowCursor} key={index}>
                {Object.keys(row).map((key) => {
                  return this.getRowCell(key, row[key], rowStyle);
                })}
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  render() {
    const { geoZone } = this.props;

    return (
      <div>
        <div>
          <b>{geoZone.info.title}</b>
          {geoZone.days.map((day) => {
            return (
              <div key={day.day} style={{ marginBottom: "10px" }}>
                {this.getDayContent(day)}
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

export default withReportsList(React.memo(GeoZoneByDayContent));
